import { TDescriptionValue } from 'shared/types/typographyComponents';

export const LIST: TDescriptionValue[][] = [
  [
    {
      value: 'Умная камера',
      isBold: true,
    },
    {
      value:
        ' с AR (технологией дополненной реальности) показывает объявления прямо в здании, на которое наведён смартфон. Это упрощает и делает более наглядным поиск, давая пользователю новую точку входа в сделку',
    },
  ],
  [
    { value: 'Будущее района:', isBold: true },
    {
      value:
        ' карта текущей и будущей инфраструктуры рядом с ЖК (метро, школы, дороги, поликлиники). Пользователи видят картину целиком и принимают более взвешенные решения',
    },
  ],
  [
    { value: 'Рейтинг транспортной доступности:', isBold: true },
    {
      value:
        ' оценка инфраструктуры и удобства локации. Для покупателей — это быстрый способ понять, насколько удобен район. Для девелоперов —подчеркнуть преимущества локации и повысить доверие клиентов',
    },
  ],
];
